import React from "react";

const SelectDateRange = ({
  name,
  label,
  labelFrom,
  labelTo,
  placeholder,
  value,
  value2,
  error,
  onFromChange,
  onToChange,
  listKey,
  listName,
  disabled,
  disabled2,
  ...rest
}) => {
  return (
    <div className="form-group">
        {label && <label htmlFor={name}>{label}</label>}
        <div className="container">
            <div className={labelFrom || labelTo ? "row border bs-border-color" : "row"}>
                <div className="col-6">
                    <div className="form-group">
                        {labelFrom && <label htmlFor={name}>{labelFrom}</label>}
                        <input
                            className="form-control"
                            value={value}
                            onChange={onFromChange}
                            name={name}
                            id={name}
                            type="date"
                            disabled={disabled}
                            {...rest}
                        >
                        </input>
                        {error && <div className="alert alert-danger">{error}</div>}
                    </div>
                </div>
                <div className="col-6">
                    <div className="form-group">
                        {labelTo && <label htmlFor={name}>{labelTo}</label>}
                        <input
                            className="form-control"
                            value={value2}
                            onChange={onToChange}
                            name={name}
                            id={name}
                            type="date"
                            disabled={disabled2}
                            {...rest}
                        >
                        </input>
                        {error && <div className="alert alert-danger">{error}</div>}
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
};

export default SelectDateRange;
